import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import Moment from "react-moment";
import {getActiveOrder} from "../../../store/cabinet/action";
import {walletShorter} from "../../../helpers/walletShorter";




const CabinetPreSaleHistory = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const orderHistory = useSelector(store => store.cabinet.orderHistory);

    const statusHandler = (status) => {
        switch (status) {
            case "pending":
                return t('Ожидает оплаты');
            case "fulfilled":
                return t('Оплачено');
            case "cancelled":
                return t('Отменено');
            case "expired":
                return t('Истекло');
            default:
                return status
        }
    }

    const colorHandler = (status) => {
        switch (status) {
            case "fulfilled":
                return Styles.colorGreen;
            case "cancelled":
            case "expired":
                return Styles.colorRed;
            default:
                return null
        }
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC} ${Styles.perspective3dXl}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dRightXl}`}>
                    <div className={`${Styles.cardBox}`}>
                        <div className={`${Styles.contentWrapTitle}`}>
                            {t("История покупок")}
                        </div>
                        <div className={`${Styles.tableWrap}`}>
                            <div className={`${Styles.tableBox}`}>
                                {orderHistory?.items?.data.length > 0 ? orderHistory?.items?.data.map((item, index) => {
                                    return (
                                        <div className={`${Styles.tableBoxRow}`} key={'order-history_' + index}>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('Дата и время')}</div>
                                                <div className={`${Styles.tableBoxItemValue}`}><Moment format="DD MMM YYYY, HH:mm">{item.paid_at ? item.paid_at : item.created_at}</Moment></div>
                                            </div>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('ID транзакции')}</div>
                                                <div
                                                    className={`${Styles.tableBoxItemValue} ${Styles.pointer}`}
                                                    onClick={()=>{navigator.clipboard.writeText(item.id)}}
                                                >
                                                    {walletShorter(item.id)}
                                                </div>
                                            </div>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('Сумма оплаты')}</div>
                                                <div className={`${Styles.tableBoxItemValue}`}>{item.fiat?.amount * 1} {item.fiat?.currency}</div>
                                            </div>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('Получено')} ${item.token_sale?.token_code}</div>
                                                <div className={`${Styles.tableBoxItemValue}`}>{item.qty} ${item.token_sale?.token_code}</div>
                                            </div>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('Цена токена')}</div>
                                                <div className={`${Styles.tableBoxItemValue}`}>{item.unit_price * 1} USD</div>
                                            </div>
                                            <div className={`${Styles.tableBoxItem}`}>
                                                <div className={`${Styles.tableBoxItemName}`}>{t('Статус')}</div>
                                                <div
                                                    className={`${Styles.tableBoxItemValue} ${item.status === 'pending' ? Styles.tableBoxItemValueClicked : null} ${colorHandler(item.status)}`}
                                                    onClick={()=>{
                                                        if (item.status === "pending"){
                                                            dispatch(getActiveOrder(item.value))
                                                        }
                                                    }}
                                                >
                                                    {statusHandler(item.status)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : <div className={`${Styles.emtyNote}`}>{t('История покупок пуста')}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetPreSaleHistory;